import { ReactElement } from "react"
import { PartnerProps } from "./partner-props"
import * as S from './partner-style'

export function Partner ({ id, values }: PartnerProps): ReactElement {
  return <S.Container id={id}>
    <S.Wrapper>
      <h5>Parceiros nacionais</h5>
      <S.Content>
        <S.ScrollContent>
          {values.items.map(item => <a href={item.link}>
            <img src={item.image} alt={item.name} />
          </a>)}
        </S.ScrollContent>
      </S.Content>
    </S.Wrapper>
  </S.Container>
}